import { fillArr } from '@hglobal/common';
import { BaseCourse } from '@education/models';

export function getCoursesSelectMock(count = 12): BaseCourse[] {
  return fillArr(count, i => ({
    id: i,
    name: `Course ${i}`,
  }));
}
